// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — draggable.styled.classic.js, новая — draggable.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './draggable.styled.classic';
import * as cp from './draggable.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
